var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import get from "lodash/get";
import classNames from "classnames";
import { ComponentClass } from 'conversional-theme';
import Boxes from '../question/questionBoxes';
import { JourneysSelectors, useAppSelector } from 'conversional-journey';
var TextBox = function (_a) {
    var _b, _c;
    var children = _a.children, type = _a.type, beforeContent = _a.beforeContent, textBoxProps = __rest(_a, ["children", "type", "beforeContent"]);
    var Box = get(Boxes, type, Boxes.default);
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    return (_jsxs(Box, __assign({ className: classNames(ComponentClass((_c = (_b = theme === null || theme === void 0 ? void 0 : theme.customizedStyles) === null || _b === void 0 ? void 0 : _b.conversionalComponents) === null || _c === void 0 ? void 0 : _c.questionTextBox)) }, textBoxProps, { children: [beforeContent, children] })));
};
export default TextBox;
